export default {
  zh: {
    titles: {
      edit: '编辑附件',
      add: '添加附件',
    },
    category: '文件类型',
    comment: '备注',
    preview: '预览',
    upload: '选择文件',
  },
  en: {
    titles: {
      edit: 'Edit Attachment',
      add: 'Add New Attachment',
    },
    category: 'Type',
    comment: 'Comment',
    preview: 'Preview',
    upload: 'Select a file',
  },
};



// WEBPACK FOOTER //
// ./src/views/Attachment/i18n.js